var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import withBranding from "@irati/brand/withBranding";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import StatusType from "@irati/wallet/types/enums/Status";
import authentication from "@irati/auth";
import PrimaryDetails from "../../../PrimaryDetails";
import { StyledProfilePicture, StyledCard } from "../../styled";
var RefundFromRewardsWallet = /** @class */ (function (_super) {
    __extends(RefundFromRewardsWallet, _super);
    function RefundFromRewardsWallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTenantWalletDetails = function (details) {
            var _a = _this.props, formatMessage = _a.formatMessage, statementItem = _a.statementItem;
            var sender = statementItem.transfer.refundToTenantWallet.sender;
            return __assign(__assign({}, details), { status: StatusType.CLEARED, ProfilePicture: React.createElement(StyledProfilePicture, { user: sender, regular: true }), title: sender.firstname + " " + sender.lastname, subTitle: formatMessage({ id: "wallet.reward.refundFromRewards.tenantSubtitle" }) });
        };
        return _this;
    }
    RefundFromRewardsWallet.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, formatMessage = _a.formatMessage, isTenantWallet = _a.isTenantWallet, branding = _a.branding;
        var tenant = authentication.userTenant();
        var currency = authentication.defaultUserCurrency();
        var primaryDetails = {
            image: branding.businessLogoUrl,
            title: tenant.public_name,
            subTitle: formatMessage({ id: "wallet.reward.refundFromRewards.subtitle" }),
            amount: statementItem.transfer.amount,
            currency: currency,
            status: StatusType.SPENT
        };
        var idNamespace = id("transfer-to-rewards-wallet", this.props);
        return (React.createElement(StyledCard, { tiny: true, noBorder: true },
            React.createElement(PrimaryDetails, { imgHeightAuto: true, id: idNamespace, data: isTenantWallet ? this.getTenantWalletDetails(primaryDetails) : primaryDetails })));
    };
    return RefundFromRewardsWallet;
}(PureComponent));
export default injectIntl(withBranding(RefundFromRewardsWallet));
